(function (module) {
    "use strict";

    module.component('forecastReject', {
        template: require('./forecastRejectComponent.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: function () {
            var $ctrl: $TSFixMe = this;

            $ctrl.$onInit = () => {
              $ctrl.title  = $ctrl.resolve.modalTitle;
            };

            $ctrl.ok = function () {
                $ctrl.close({ $value: $ctrl.comment });
            };

            $ctrl.cancel = function () {
                $ctrl.dismiss({ $value: 'cancel' });
            };

        }
    })

})(angular.module('topline.modules'));